import KbAdmin from 'models/location/kb_admin';

export default class NavigateToKbAdmin {
  constructor(context) {
    this.context = context;
  }

  run(snippetId) {
    let kbAdmin = KbAdmin.create();
    this.context.router.navigateTo(kbAdmin);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/navigate_to_kb_admin.js